export const RECENT_INVOICES_GRID =
  "hidden items-center gap-x-xl md:grid md:grid-cols-[auto_minmax(150px,170fr)_minmax(230px,248fr)_minmax(100px,100fr)_minmax(72px,90fr)_auto] lg:grid-cols-[auto_minmax(150px,170fr)_minmax(200px,380fr)_minmax(230px,248fr)_minmax(100px,100fr)_minmax(72px,90fr)_auto]";
